// this reducer stores the screen shot request time
// firebase data is stored here:
// https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/cuserScreenShot/89bd5a

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  requestTime: null,
};

const eventSlice = createSlice({
  name: 'screenshot',
  initialState,
  reducers: {
    setRequestTime(state, {payload: requestTime = null}) {
      state.requestTime = requestTime;
    },
  },
});

export const {setRequestTime} = eventSlice.actions;

export default eventSlice.reducer;
